import React, { useEffect, useState } from 'react'
import fillingStationService from 'Services/fillingStationService'
import { FillingStationType } from 'Models/fillingStationType'

interface StockManagementTableProps {
  pageNumber: number
  pageSize: number
  onTotalChange: (total: number, pageSize?: number) => void
  onLoadingChange?: (loading: boolean) => void
}

const StockManagementTable: React.FC<StockManagementTableProps> = ({
  pageNumber,
  onTotalChange,
  onLoadingChange,
}) => {
  const [stations, setStations] = useState<FillingStationType[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let cancelled = false
    const fetchStockStations = async () => {
      try {
        setIsLoading(true)
        onLoadingChange?.(true)
        const res = await fillingStationService.getAll(pageNumber)
        if (cancelled) return

        const responseData = res.data?.data
        setStations(responseData?.dataset ?? [])
        onTotalChange(responseData?.total ?? 0, responseData?.pageSize)
      } catch {
        if (!cancelled) {
          setStations([])
          onTotalChange(0)
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false)
          onLoadingChange?.(false)
        }
      }
    }
    fetchStockStations()
    return () => {
      cancelled = true
    }
  }, [pageNumber, onTotalChange, onLoadingChange])

  return (
    <div className='bx-table-wrapper'>
      <table className='bx-table'>
        <thead>
          <tr>
            <th className='bx-finance__col-station'>Filling Station</th>
            <th className='bx-finance__col-volume'>Vol Sold Today</th>
            <th className='bx-finance__col-volume'>Vol Left</th>
            <th className='bx-finance__col-amount'>Amount Sold</th>
            <th className='bx-finance__col-status'>Status</th>
            <th className='bx-finance__col-action'>Action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={6} className='bx-finance__empty'>
                Loading...
              </td>
            </tr>
          ) : stations.length ? (
            stations.map((station, index) => {
              const isOptimal = index % 2 === 0
              return (
                <tr key={station.id}>
                  <td className='bx-finance__col-station'>{station.businessName}</td>
                  <td className='bx-finance__col-volume'>0</td>
                  <td className='bx-finance__col-volume'>0</td>
                  <td className='bx-finance__col-amount'>₦0.00</td>
                  <td className='bx-finance__col-status'>
                    <span
                      className={`bx-status-pill bx-status-pill--${isOptimal ? 'optimal' : 'low'}`}
                    >
                      {isOptimal ? 'Optimal' : 'Low'}
                    </span>
                  </td>
                  <td className='bx-finance__col-action'>
                    <button className='bx-view-link btn btn-sm btn-default' type='button'>
                      View
                    </button>
                  </td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan={6} className='bx-finance__empty'>
                No records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default StockManagementTable
